// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1CVaI","inner":"Footer_inner__2Ywea","nextIcon":"Footer_nextIcon__32PIc","innerLeft":"Footer_innerLeft__1eaZl"};